import { Inject, Injectable } from '@angular/core';
import { IdentificationProvider } from '@shared/enums/identification-provider.enum';
import { IdentificationProviderService } from './identification-provider.service';
// import { DOCUMENT } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { DialogService } from '../shared/services/dialog.service';
import { AuthLSMConfig } from './auth.config';

@Injectable()
export class IdentificationLMSProviderService extends IdentificationProviderService {

  constructor(
    protected readonly oauthService: OAuthService,
    protected readonly dialogService: DialogService,
    protected readonly translateService: TranslateService,
    private readonly authConfig: AuthLSMConfig,
    // @Inject(DOCUMENT) private readonly document: Document,
  ){
    super(oauthService,dialogService,translateService);
  }

  public async login(identificationProvider: IdentificationProvider, redirectUri?: string) {
    window.open(`${this.authConfig.loginUrl}?kc_idp_hint=${ identificationProvider }`, '_self');
    //this.document.location.href = `${this.authConfig.loginUrl}?kc_idp_hint=${ identificationProvider }`;
  }

}